<template>
  <div class="pdp-buynow-container">
    <div
      class="pdp-card-container"
      :class="borderTopClass"
    >
      <div
        v-if="showBannerDetails"
        class="d-none d-lg-flex"
      >
        <div class="pdp-banner pdp-text ml-auto" :class="`sumo-bg-${bannerBgColor}`">
          <DealBannerContent
            :banner-details="bannerDetails"
            :tooltip-id="`desktop-deal-banner-tooltip-${idSuffix}`"
          />
        </div>
      </div>
      <div
        class="pdp-buynow-card"
        :class="{ 'pdp-buynow-card-top-padding': !showBannerDetails }"
      >
        <div
          v-if="$options.LISTING_TYPES_WITH_LOGO.includes(deal.listing_type)"
          class="d-none d-lg-block mt-2 mb-3"
        >
          <ListingTypeLogo
            :public-name="deal.public_name"
            :listing-type="deal.listing_type"
            :tooltip-id="`desktop-listing-type-tooltip-${idSuffix}`"
          />
        </div>
        <h1 class="d-none d-lg-block pdp-section-title font-weight-bold col-12 p-0 h2">
          {{ deal.public_name }}
        </h1>
        <div class="d-none d-lg-flex mb-3">
          <div
            v-if="!deal.is_info"
            class="flex-grow-1 plan-type"
          >
            {{ planTypeText }}
          </div>
        </div>
        <h2
          v-if="subheader && !deal.is_info"
          class="d-none d-lg-block pdp-product-subtitle p-0 col-12"
        >
          {{ subheader }}
        </h2>
        <div
          v-if="!(deal.is_preview || deal.is_info) || isReportable"
          class="d-none d-lg-flex justify-content-between mb-3"
        >
          <TacoRating
            v-if="!(deal.is_preview || deal.is_info)"
            class=" m-0"
            :deal="deal"
          />
          <a
            v-if="isReportable"
            class="d-none d-lg-inline-block float-right"
            :href="reportUrl"
            target="_blank"
          >
            Report listing
            <font-awesome-icon
              icon="external-link-alt"
              height="16"
              width="16"
            />
          </a>
        </div>

        <PDPPricingInfo
          :deal="deal"
          :buy-button="buyButton"
          :plans="deal.plans"
          :user-has-plus="user.hasPlus"
          :banner-details="bannerDetails"
          :is-pricing-card-email-submitted="isPricingCardEmailSubmitted"
          class="mt-3"
          @changePlan="onChangePlan"
        />
      </div>

      <!-- Upsell Callout contianer -->
      <DealUpsellCallout
        v-if="deal.upsell_callout"
        :upsell-callout="deal.upsell_callout"
      />
      <PricingCardGuaranteeWrapper
        v-if="deal.money_back_callout_type"
        :callout-type="deal.money_back_callout_type"
        :refundable-days="deal.refundable_days"
        :is-freebie="deal.is_free"
        :interval="planInterval"
      />
    </div>

    <AskSumoCallout
      v-if="showAskSumo"
      class="mt-3"
    />

    <PDPTimerExperiment
      v-if="displayTimer && showNewTimer"
      class="d-inline-block mt-4"
      :date="deal.dates.end_date"
    />
    <PDPTimer
      v-else-if="displayTimer"
      class="col-12 mx-0 mt-4 row d-flex justify-content-center"
      :date="deal.dates.end_date"
    />

    <div
      v-if="isReportable"
      class="d-flex d-lg-none justify-content-center w-100 py-2"
    >
      <a
        class="pdp-buynow-report float-right"
        :href="reportUrl"
        target="_blank"
      >
        Report listing
        <font-awesome-icon
          icon="external-link-alt"
          height="16"
          width="16"
        />
      </a>
    </div>
  </div>
</template>

<script>
// TODO:BRO-1276: replace DTacoRating, DDropdownItem, DButton where possible
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { PDP_ASKSUMO_EXPERIMENT_NAME, PDP_DESKTOP_TIMER_EXPERIMENT_NAME } from '@/constants/global';
import PlusImage from '../../../static/images/home/as-plus-2.svg';
import PDPPricingInfo from './PDPPricingInfo.vue';
import { LISTING_TYPES_WITH_LOGO } from '~/constants/listing-types';

export default {
  LISTING_TYPES_WITH_LOGO,
  components: {
    PDPPricingInfo,
    FontAwesomeIcon,
    PDPTimer: () => import('./util/PDPTimer.vue'),
    PDPTimerExperiment: () => import('./util/PDPTimerExperiment.vue'),
    PricingCardGuaranteeWrapper: () => import('./PricingCardGuaranteeWrapper.vue'),
    DealUpsellCallout: () => import('./util/DealUpsellCallout.vue'),
    TacoRating: () => import('../utilities/TacoRating.vue'),
    ListingTypeLogo: () => import('./ListingTypeLogo.vue'),
    DealBannerContent: () => import('./DealBannerContent.vue'),
    AskSumoCallout: () => import('./AskSumoCallout.vue'),
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
    buyButton: {
      type: Object,
      required: true,
    },
    planTypeText: {
      type: String,
      required: true,
    },
    subheader: {
      type: String,
      required: false,
      default: '',
    },
    plans: {
      type: Array,
      required: false,
      default: () => [],
    },
    // TODO temp user object to be replaced by this.$store.state.session.user
    user: {
      type: Object,
      required: true,
    },
    idSuffix: {
      type: String,
      required: true,
    },
    isPricingCardEmailSubmitted: {
      type: Boolean,
      required: true,
    },
    bannerDetails: {
      type: Object,
      default: null,
    },
    showBannerDetails: {
      type: Boolean,
      default: false,
    },
    displayTimer: {
      type: Boolean,
      default: false,
    },
    planInterval: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      plusImage: PlusImage,
      isDisabled: false,
      tooltipText: `This is a short description of what AppSumo Select means.
                    We should cap this to only be a few lines in length.`,
      mobileMatchMedia: null,
    };
  },
  computed: {
    showNewTimer() {
      return this.$store.getters['experiments/getExperimentVariant'](
        PDP_DESKTOP_TIMER_EXPERIMENT_NAME,
      ) === 'enabled';
    },
    showAskSumo() {
      if (this.user?.isAuthenticated) return false;

      return this.$store.getters['experiments/getExperimentVariant'](
        PDP_ASKSUMO_EXPERIMENT_NAME,
      ) === 'enabled';
    },
    selectedPlan() {
      return this.$store.state.selectedPlan?.plan;
    },
    bannerBgColor() {
      return this.bannerDetails?.bg_color;
    },
    borderTopClass() {
      if (!this.bannerBgColor || !this.showBannerDetails) {
        return null;
      }

      return `sumo-border-top-4-${this.bannerBgColor}`;
    },
    infoDealQuestionText() {
      return `Want to see ${this.deal.public_name} on AppSumo?`;
    },
    clickthroughUrl() {
      return this.deal.clickthrough_url;
    },
    disabledBuyButton() {
      return this.disabledState || this.buyButton.is_coming_soon;
    },
    canAddToCart() {
      const { buyButton } = this;
      return !(buyButton.is_draft || buyButton.is_ended || buyButton.is_coming_soon);
    },
    defaultPriceText() {
      const formattedPrice = this
        .$options
        .filters
        .currencyWithOptionalDecimal(this.deal.default_price);

      if (this.deal.plan_stack_count > 1) {
        return `Starting at ${formattedPrice}`;
      }

      return formattedPrice;
    },
    selectedPriceText() {
      if (this.selectedPlan) {
        return this.getPlanDisplayText(this.selectedPlan);
      }

      return this.defaultPriceText;
    },
    isReportable() {
      // let's only allow reporting for self-listing/marketplace
      if (!this.deal.is_marketplace) {
        return false;
      }

      // info deals are 'marketplace', but we control them, so let's not allow reporting
      if (this.deal.is_info) {
        return false;
      }

      return this.user?.isAuthenticated || this.user?.isStaff;
    },
    reportUrl() {
      // jl: as this method's used right now, user is guaranteed to be non-empty.
      // while it won't error due to the presence of a default user value, for future uses
      // of reportUrl(), let's make sure the user object is non-empty
      return `https://report-offer.paperform.co/?deal_id=${this.deal.id}&deal_slug=
              ${this.deal.slug}&email=${this.user.email}`;
    },
    isAuthenticated() {
      return this.user.isAuthenticated;
    },
    hasPlans() {
      return this.plans && this.plans.length > 1;
    },
    disabledState() {
      if (this.buyButton.is_ended) {
        return true;
      }
      if (this.hasPlans) {
        return !this.selectedPlan;
      }
      return this.isDisabled;
    },
    stageDetails() {
      return this.deal.stage_details || {};
    },
    lowCodesRemaining() {
      return this.deal.shows_codes_remaining && this.deal.codes_remaining > 0;
    },
    inactiveIndefinitely() {
      return this.stageDetails.is_inactive_indefinitely;
    },
    earlyAccessOrLastCall() {
      return this.buyButton.is_early_access || this.buyButton.is_last_call;
    },
    notPlusAndEarlyAccessOrLastCall() {
      return !this.user.hasPlus && this.earlyAccessOrLastCall;
    },
  },
  methods: {
    // seems silly, but let's centralize this common format into a helper function.
    getPlanDisplayText(plan) {
      const name = this.deal.use_licensing ? plan.public_name : this.pluralizeCodeText(plan.codes);

      return `${name} : ${this.$options.filters.currencyWithOptionalDecimal(plan.price)}`;
    },
    pluralizeCodeText(code) {
      return `${code} Code${code > 1 ? 's' : ''}`;
    },
    onChangePlan(plan) {
      this.$store.dispatch(
        'selectedPlan/updatePlan',
        { selectedPlan: plan },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~/styles/dorado/themes/dorado';
  @import '../../styles/abstracts/mixins';
  @import '../../styles/utils/breakpoints';

  /* stylelint-disable selector-no-qualifying-type */
  h2.pdp-product-subtitle {
    font-family: Roboto, sans-serif;
    font-size: 16px;
    font-weight: 400 !important;
    line-height: 24px;
  }

  .plan-type {
    color: #434d59;
    font-weight: 700;
  }

  a.pdp-buynow-report {
    font-size: 16px;
    padding: 8px 0;
  }

  [data-popover='select'] {
    border-radius: 4px;
    color: #ffff;
    padding: 15px;
    font-size: 12px;
    width: 300px !important;
    border: 1px solid rgba(0, 0, 0, 0.2);
    background-color: #09292b !important;
    margin-top: -6px;
  }

  .pdp-buynow-card {
    text-align: center;
  }

  @include media-breakpoint-down(md) {
    // due to nature of pricing card being overloaded, we need this temp hack to prevent
    // deal stage banner border from appearing on mobile
    div[class*='sumo-border-top-4-'] {
      border-top: 0 !important;
    }
  }

  @media (min-width: 992px) {
    .pdp-card-container {
      @include pdp-card-style;
    }

    .pdp-banner {
      margin-right: 24px;
      border-radius: 0 0 4px 4px;
      padding: 4px 8px;
      font-weight: 500px;
    }

    .pdp-buynow-card-top-padding {
      padding-top: 28px;
    }

    div.pdp-buynow-card {
      padding-left: 28px;
      padding-right: 28px;
      padding-bottom: 28px;
      text-align: left;
    }
  }
  /* stylelint-enable selector-no-qualifying-type */

  .success {
    background: #0a840a;
    padding: 16px 20px;
    color: #fff;
    display: inline-flex;
    align-items: center;
  }

  .pdp-add-to-cart-btn {
    margin: 1rem 0 0;

    // Having to include this rule instead of the standard media breakpoint
    //  because of the above definition...
    @media (min-width: 992px) {
      margin: 0 0 0 1rem;
    }
  }

  .sumo-border-top-4-pdp-black-friday-bg-color {
    border-top: 4px solid #ffca54 !important;
  }

  .sumo-bg-pdp-black-friday-bg-color {
    background-color: #ffca54;
  }
</style>
